export default __webpack_public_path__ + "src/images/packages/palms-on-the-rocks/589b51cde32b250611166f7ab0650758-5.jpg";